import { useLocation as useReactRouterLocation } from 'react-router-dom';

const useLocation = () => {
  const location = useReactRouterLocation();
  return location;
};

export default useLocation;
